import React, { useContext } from 'react'

export const FirmContext = React.createContext({
  firmID: '',
  firm: null,
  setFirmID: () => {},
})

export const useFirm = () => useContext(FirmContext)
